{
  "white": {
    "color": "#ffffff"
  },
  "overlay": {
    "color": "rgba(#222222, 0.5)"
  },
  "transparent": {
    "color": "transparent"
  },
  "inherit": {
    "color": "inherit"
  },
  "black": {
    "color": "#222222"
  },
  "purple100": {
    "color": "#fbf4ff"
  },
  "purple200": {
    "color": "#edc8ff"
  },
  "purple300": {
    "color": "#de99ff"
  },
  "purple400": {
    "color": "#c158f8"
  },
  "purple500": {
    "color": "#990ae3"
  },
  "purple600": {
    "color": "#7d00bd"
  },
  "purple700": {
    "color": "#5f008f"
  },
  "purple800": {
    "color": "#3f005e"
  },
  "purple900": {
    "color": "#1f002e"
  },
  "gray100": {
    "color": "#fbfbfb"
  },
  "gray200": {
    "color": "#f2f2f2"
  },
  "gray300": {
    "color": "#cccccc"
  },
  "gray400": {
    "color": "#a0a0a0"
  },
  "gray500": {
    "color": "#6e6e6e"
  },
  "gray600": {
    "color": "#5e5e5e"
  },
  "gray700": {
    "color": "#4e4e4e"
  },
  "gray800": {
    "color": "#303030"
  },
  "gray900": {
    "color": "#222222"
  },
  "red100": {
    "color": "#fff4f7"
  },
  "red200": {
    "color": "#ffccdd"
  },
  "red300": {
    "color": "#ffa4c3"
  },
  "red400": {
    "color": "#f74f87"
  },
  "red500": {
    "color": "#e4175c"
  },
  "red600": {
    "color": "#be0040"
  },
  "red700": {
    "color": "#900030"
  },
  "red800": {
    "color": "#5e0020"
  },
  "red900": {
    "color": "#2e000f"
  },
  "green100": {
    "color": "#f3fff9"
  },
  "green200": {
    "color": "#c5f8de"
  },
  "green300": {
    "color": "#95f4c3"
  },
  "green400": {
    "color": "#48e494"
  },
  "green500": {
    "color": "#00d066"
  },
  "green600": {
    "color": "#00af56"
  },
  "green700": {
    "color": "#008641"
  },
  "green800": {
    "color": "#00592b"
  },
  "green900": {
    "color": "#002e16"
  },
  "orange100": {
    "color": "#fffaf4"
  },
  "orange200": {
    "color": "#ffefcb"
  },
  "orange300": {
    "color": "#ffe39f"
  },
  "orange400": {
    "color": "#ffc14d"
  },
  "orange500": {
    "color": "#ff9b00"
  },
  "orange600": {
    "color": "#d27f00"
  },
  "orange700": {
    "color": "#a86600"
  },
  "orange800": {
    "color": "#6b4100"
  },
  "orange900": {
    "color": "#2e1c00"
  },
  "blue100": {
    "color": "#f4faff"
  },
  "blue200": {
    "color": "#cbefff"
  },
  "blue300": {
    "color": "#9fe2ff"
  },
  "blue400": {
    "color": "#4dc0ff"
  },
  "blue500": {
    "color": "#0099ff"
  },
  "blue600": {
    "color": "#007acc"
  },
  "blue700": {
    "color": "#005f9e"
  },
  "blue800": {
    "color": "#003d65"
  },
  "blue900": {
    "color": "#001c2e"
  }
}
